/**
 * Set contact subject in input hidden while inputting contact name
 */
function setUpContactSubjectOnNameInput() {
  const inputName = document
    .querySelector('input[type="text"][id="inputName"]') as HTMLInputElement;
  const inputSubkect = document
    .querySelector('input[type="hidden"][id="inputSubject"]') as HTMLInputElement;

  const subject = '[MARKETPLACE LISEN.SI] Inquiry from ';

  if (inputName && inputSubkect) {
    inputName.addEventListener('keyup', () => {
      inputSubkect.value = subject + inputName.value;
    });
  }
}

/**
 * Change the clientarea sidebar link's 'Order New Services'
 */
function setUpClientAreaSidebarLink() {
  const sidebarItemLink = document
    .querySelector('a[menuitemname="Order New Services"]') as HTMLAnchorElement;
  if (sidebarItemLink) {
    sidebarItemLink.href = '/index.php';
  }
}

/**
 * Handle product/license search and render results to dom
 */
function setUpProductSearch() {
  const apiUrl = '/search-product.php?search=';
  const forms = document.querySelectorAll('form.b-search__form');

  forms.forEach((form) => {
    const resultWrapper = form.nextElementSibling;
    const input = form.querySelector('input');
    const button = form.querySelector('button');
    
    if (!resultWrapper || !input || !button) return;

    const resultListWrapper = resultWrapper.querySelector('.b-search-results__card');

    if (!resultListWrapper) return;

    const closeResults = () => {
      setTimeout(() => {
        resultWrapper.classList.remove('is-active');
      }, 250);
    };

    input.addEventListener('blur', closeResults);
    button.addEventListener('blur', closeResults);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      setTimeout(() => {
        resultWrapper.classList.add('is-active');
      }, 500);

      resultListWrapper.innerHTML = `
        <div class="b-search-results__not-found is-active">
          Searching..
        </div>
      `;

      const encodedKeyword = encodeURIComponent(input.value);
      const response = await fetch(`${apiUrl}${encodedKeyword}`);

      type SearchResult = { name: string; id: string };
      const results: SearchResult[] = await response.json();
      
      // map results to dom
      if (results.length) {
        resultListWrapper.innerHTML = '';
        results.forEach((res) => {
          const a = document.createElement('a');
          a.href = `/cart.php?a=add&pid=${res.id}`;
          a.textContent = res.name;
          a.className = 'b-search-results__product is-active';
          resultListWrapper.appendChild(a);
        });
      } else {
        resultListWrapper.innerHTML = `
          <div class="b-search-results__not-found is-active">
            No results found.
          </div>
        `;
      }
    });
  });
}

/**
 * Render domain pricing table from whmcs data feeds
 */
function setUpDomainPricingTable() {
  // get and parse raw table data from whmcs feeds
  const parseDynamicTable = (): Record<string, string | number>[] => {
    const table = document.querySelector<HTMLTableElement>('table.domainpricing');
    if (!table) return [];
  
    table.style.display = 'none';
    const rows = Array.from(table.querySelectorAll('tbody tr'));
  
    const headerCells = Array.from(rows.shift()?.querySelectorAll('th') || []);
    const headers = headerCells.map(h => h.textContent?.trim() || '');
  
    // get all rows value
    return rows.map(row => {
      const cells = Array.from(row.querySelectorAll('td'));
      const obj: Record<string, string | number> = {};
      headers.forEach((header, i) => {
        let value: string | number = cells[i]?.textContent?.trim() || '';

        if (!isNaN(Number(value))) {
          value = Number(value);
        }
        obj[header] = value;
      });
      return obj;
    });
  }

  // render domain pricing table to dom
  const renderPricingTable = (data: Record<string, string | number>[]) => {
    const tbody = document.querySelector<HTMLTableSectionElement>(
      '.lisensi-domain-pricing__tbody'
    );
    if (!tbody) return;
  
    tbody.innerHTML = '';
  
    data.forEach(item => {
      const tld = item['TLD'];
      const minYears = item['Min. Years'];
      const register = item['Register'];
      const transfer = item['Transfer'];
      const renew = item['Renew'];
  
      const row = document.createElement('tr');
  
      row.innerHTML = `
        <td>
          <span class="b-tld-extension">${tld}</span>
        </td>
        <td>
          <div class="b-tld-price">
            <strong>${register}</strong>
            <small>${minYears} Year${Number(minYears) > 1 ? 's' : ''}</small>
          </div>
        </td>
        <td>
          <div class="b-tld-price">
            <strong>${transfer}</strong>
            <small>${minYears} Year${Number(minYears) > 1 ? 's' : ''}</small>
          </div>
        </td>
        <td>
          <div class="b-tld-price">
            <strong>${renew}</strong>
            <small>${minYears} Year${Number(minYears) > 1 ? 's' : ''}</small>
          </div>
        </td>
      `;
  
      tbody.appendChild(row);
    });
  }

  const parsed = parseDynamicTable();
  renderPricingTable(parsed);
}

/**
 * Handle form validation in register form
 */
function setUpRegisterForm() {
  const errorState: string[] = [];

  const registerValidation = () => {
    const fakeSubmitBtn = document
      .querySelector('.b-form__submit button[type="button"]');
    const submitBtn = document
      .querySelector('.b-form__submit input[type="submit"]') as HTMLButtonElement;
    const form = document
      .querySelector('form.b-form--register') as HTMLFormElement;

      if (!fakeSubmitBtn || !submitBtn || !form) return;
    disableSubmitOnEnter(form);

    // only submit form if all validations pass
    fakeSubmitBtn.addEventListener('click', () => {
      validateForm(form, () => {
        submitBtn.click();
      });
    });
  }

  const validateForm = (form: HTMLFormElement, cb: () => void) => {
    resetErrorState();

    validateMaxCharacters('First name', form.firstname.value, 64);
    validateAllowedCharacters('First name', form.firstname.value);

    validateMaxCharacters('Last name', form.lastname.value, 64);
    validateAllowedCharacters('Last name', form.lastname.value);

    validateEmail(form.email.value);

    if (form.companyname.value) {
      validateMaxCharacters('Company name', form.companyname.value, 64);
      validateAllowedCharacters('Company name', form.companyname.value);
    }

    if (form.address1.value) {
      validateAllowedCharacters('Street address 1', form.address1.value);
    }

    if (form.address2.value) {
      validateAllowedCharacters('Street address 2', form.address2.value);
    }

    validateMaxCharacters('Postcode', form.postcode.value, 5);
    mapErrorToDom();

    if (errorState.length === 0) {
      cb();
    }
  }

  const validateMaxCharacters = (
    fieldName: string,
    value: string,
    maxLength: number
  ) => {
    if (value.length > maxLength) {
      const message = `${fieldName} cannot be longer than ${maxLength} characters.`;
      errorState.push(message);
    }
  }

  const validateEmail = (value: string) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!value.match(emailRegex)) {
      const message = 'Please enter a valid email address';
      errorState.push(message);
    }
  }

  const validateAllowedCharacters = (fieldName: string, value: string) => {
    const allowedCharsRegex = /^[a-zA-Z0-9._-\s]+$/;

    if (!value.match(allowedCharsRegex)) {
      const message = `${fieldName} can only contain alphanumeric characters, dot (.), underscore (_), and dash (-).`;
      errorState.push(message);
    }
  }

  const resetErrorState = () => {
    errorState.splice(0, errorState.length);
  }

  const mapErrorToDom = () => {
    const errorWrapper = document.querySelector('.b-form__error');
    if (!errorWrapper) return;

    errorWrapper.innerHTML = '';

    if (errorState.length) {
      const ul = document.createElement('ul');
      
      errorState.forEach((err) => {
        const li = document.createElement('li');
        li.textContent = err;
        ul.appendChild(li);
      });

      errorWrapper.appendChild(ul);
      errorWrapper.classList.add('is-active');
    } else {
      errorWrapper.classList.remove('is-active');
    }
  }

  const disableSubmitOnEnter = (form: HTMLFormElement) => {
    form.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.code === 'Enter') {
        event.preventDefault();
      }
    })
  }

  registerValidation();
}

function init() {
  setUpContactSubjectOnNameInput();
  setUpClientAreaSidebarLink();
  setUpProductSearch();
  setUpRegisterForm();
  setUpDomainPricingTable();
}

document.addEventListener('DOMContentLoaded', init);
